import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ScatteredTools } from './components/ScatteredTools';
import { Story } from './components/Story';
import { Philosophy } from './components/Philosophy';
import { WhyStopply } from './components/WhyStopply';
import { CSVSection } from './components/CSVSection';
import { ManagedBy } from './components/ManagedBy';
import { Integrations } from './components/Integrations';
import { Gallery } from './components/Gallery';
import { AISection } from './components/AISection';
import { Comparison } from './components/Comparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { LeadModal } from './components/LeadModal';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  return <div className="min-h-screen bg-background text-textPrimary font-sans selection:bg-accent/30 selection:text-white" data-id="element-0">
      <Navbar onOpenModal={handleOpenModal} data-id="element-1" />

      <main data-id="element-2">
        <Hero onOpenModal={handleOpenModal} data-id="element-3" />
        <ScatteredTools data-id="element-4" />
        <Story data-id="element-5" />
        <Philosophy data-id="element-6" />
        <WhyStopply data-id="element-7" />
        <CSVSection data-id="element-8" />
        <ManagedBy data-id="element-9" />
        <Integrations data-id="element-10" />
        <Gallery data-id="element-11" />
        <AISection data-id="element-12" />
        <Comparison data-id="element-13" />
        <FinalCTA onOpenModal={handleOpenModal} data-id="element-14" />
      </main>

      <Footer data-id="element-15" />

      <LeadModal isOpen={isModalOpen} onClose={handleCloseModal} data-id="element-16" />
    </div>;
}